import produce from 'immer';

import {
  HOLDER_LOG_LIST_REQUEST
} from '../../constants/log/holderLogConstants';

const initialState = {

};

const holderLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case HOLDER_LOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default holderLogReducer;
